import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export const DATE_PARTS_COUNT = 3;
export const MS_POSITION = 5;
export const MINUTES_IN_HOUR = 60;
export const MS_IN_SECOND = 1000;

export function formatDate(date: string) {
  if (!date) {
    return '';
  }

  const datePart = date.includes('T') ? date.split('T')[0] : date;

  if (datePart.split('-').length === DATE_PARTS_COUNT) {
    const [year, month, day] = datePart.split('-');
    return `${day}.${month}.${year}`;
  }

  return date;
}

export function formatDatetime(dateTime: string | null | undefined, dateOnly: boolean = true) {
  if (!dateTime) {
    return '-';
  }

  if (dateTime.includes('0001')) {
    return '-';
  }

  if (dateTime.includes('T') && dateTime.includes('Z')) {
    const date = new Date(dateTime);

    if (dateOnly) {
      return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
    }

    return `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  }

  const [date, time] = dateTime.split('T');
  const formattedDate = formatDate(date);

  if (dateOnly) {
    return formattedDate;
  }

  return `${formattedDate}, ${time.slice(0, MS_POSITION)}`;
}
export function formatTime(time: string | null | undefined): string {
  return time?.length ? time.substring(0, 5) : '';
}

export function formatToServerDate(date: string) {
  if (!date) {
    return '';
  } else if (date.split('.').length === DATE_PARTS_COUNT) {
    const [day, month, year] = date.split('.');
    return `${year}-${month}-${day}`;
  }

  return date;
}

export function convertNgbDateToISOString(ngbDate: NgbDate): string {
  const date = new Date(Date.UTC(ngbDate.year, ngbDate.month - 1, ngbDate.day));

  // Convert to ISO string and return
  return date.toISOString(); // Output will be in 'YYYY-MM-DDTHH:mm:ss.sssZ' format
}

export function convertIsoStringToNgbDate(isoString: string): NgbDate | null {
  const date = new Date(isoString);

  if (!isNaN(date.getTime())) {
    return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }

  return null;
}

export function isNowInDateRange(dateFrom: string, dateTo: string): boolean {
  const now = new Date();
  const from = new Date(dateFrom);
  const to = new Date(dateTo);

  return now >= from && now <= to;
}

export function setDateToStartOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function isDateBeforeToday(dateString: string): boolean {
  if (!dateString) return false;

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return false;

  return setDateToStartOfDay(date).getTime() < setDateToStartOfDay(new Date()).getTime();
}

export function isDateAfterToday(dateString: string): boolean {
  if (!dateString) return false;

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return false;

  return setDateToStartOfDay(date).getTime() > setDateToStartOfDay(new Date()).getTime();
}

export function isDateTodayOrAfter(dateString: string): boolean {
  if (!dateString) return false;

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return false;

  return setDateToStartOfDay(date).getTime() >= setDateToStartOfDay(new Date()).getTime();
}

export function convertTimeToString(time: number): string | null {
  const hours = Math.floor(time / MINUTES_IN_HOUR);
  const minutes = time % MINUTES_IN_HOUR;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
}

export function convertStringToTime(time: string): number | null {
  if (!time) {
    return null;
  }

  const [hours, minutes] = time.split(':').map(Number);
  return hours * MINUTES_IN_HOUR + minutes;
}
